/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const jobiqoRoutesConfig = require('./../src/jobiqo/config/routes');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoRoutesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  routes: [...jobiqoRoutesConfig.routes],
  redirects: [
    ...jobiqoRoutesConfig.redirects,
    // Redirect blog images to community.thejobnetwork.com uploads folder.
    // Example: https://community.thejobnetwork.com/wp-content/uploads/2022/10/pexels-lê-minh-977213-145x100.jpg
    {
      source: '/wp-content/uploads/:slug*',
      destination: 'https://community.thejobnetwork.com/wp-content/uploads/:slug*',
      basePath: false,
      permanent: false,
    },
  ]
});
